export const BUTTON_ID = {
  CONTACTEZ: "contactez_nous",
  DEMARRER: "demarrer",
};
